import { render } from "./ButtonFilter.vue?vue&type=template&id=15fcb4c0"
import script from "./ButtonFilter.vue?vue&type=script&lang=js"
export * from "./ButtonFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__